import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { useContextSelector } from 'use-context-selector';
import Header from '../../../components/Header';
import { ModalConfirmClose } from '../../../components/ModalConfirmClose';

import { PlatformContext } from '../../../contexts/PlatformContext';
import { RouterContext } from '../../../contexts/RouterContext';
import { PAGES_COMPONENTS } from './pageComponents';
import { pageRoutes } from './pages';
import useOnCloseSchedule from '../../../hooks/useOnCloseSchedule';

const Template = styled.div`
  width: 100%;
  height: var(--height-full);
  padding-top: 72px;

  @media (min-width: 900px) {
    width: 100%;
    margin: 0 auto;
    padding-top: 72px;
  }
`;

export function GeneralRouter({ routeTo }: { routeTo: number }) {
  const { currentStep, totalSteps } = useContextSelector(RouterContext, state => state);
  const route = useContextSelector(RouterContext, state => state.route);
  const { isModalCloseOpen, setModalCloseOpen, setSelectedUnit, setFixedModule } = useContextSelector(
    PlatformContext,
    state => state
  );

  const { goTo } = useContextSelector(RouterContext, state => state);

  React.useEffect(() => {
    goTo(routeTo);
  }, []);

  const cancelCloseModal = () => setModalCloseOpen && setModalCloseOpen(false);

  const { onCloseSchedule, confirmReset } = useOnCloseSchedule({});

  let renderPageSchedule: ReactElement = <></>;
  const identityPageSchedule = pageRoutes(route || 0);

  if (identityPageSchedule) renderPageSchedule = <>{PAGES_COMPONENTS[identityPageSchedule.id]}</>;

  return (
    <Template>
      <Header
        onClose={onCloseSchedule}
        title={pageRoutes(route)?.title}
        nextPage={pageRoutes(route)?.nextPage}
        currentStep={currentStep}
        totalSteps={totalSteps}
      />
      {/* <BodyApplication> */}
      {renderPageSchedule}
      {/* </BodyApplication> */}
      <ModalConfirmClose visible={!!isModalCloseOpen} onConfirmClose={confirmReset} onCancelClose={cancelCloseModal} />
    </Template>
  );
}
